module.exports = __webpack_public_path__ + "img/eq-monarch.fc315cec.png";